// @ts-nocheck
import React, { useState } from 'react';

const TooltipMouseFollow = ({ message }) => {
	const [visible, setVisible] = useState(false);
	const [coords, setCoords] = useState({ x: 0, y: 0 });

	const handleMouseMove = (e) => {
		setCoords({ x: e.clientX, y: e.clientY });
	};

	return (
		<div
			className="relative inline-block"
			onMouseEnter={() => setVisible(true)}
			onMouseLeave={() => setVisible(false)}
			onMouseMove={handleMouseMove}
		>
      <span className="text-green-cl cursor-pointer text-[10px] border border-green-cl rounded-full w-4 h-4 flex items-center justify-center font-bold leading-none">
        ?
      </span>

			{visible && (
				<div
					className="fixed z-50 px-3 py-2 text-xs text-white bg-green-cl rounded shadow-md pointer-events-none transition-opacity duration-100"
					style={{
						top: `${coords.y + 15}px`,
						left: `${coords.x + 15}px`,
					}}
				>
					{message}
				</div>
			)}
		</div>
	);
};

export default TooltipMouseFollow;